import { Spacing } from '../constants/spacing';
export const LIST_ITEM_BULLET_POINT_SIZE = 24;
export const LIST_ITEM_BULLET_POINT_SPACING = Spacing.SPACE_12;